import React, { FC } from "react";
import { useHistory, useLocation, useParams } from "react-router-dom";
import StickyHeader from "modules/Common/Components/StickyHeader";
import StickyHeaderContent from "modules/Common/Components/StickyHeaderContent";
import StickyHeaderContentWithBackButton from "modules/Common/Components/StickyHeaderContentWithBackButton";
import TabsWrapper from "modules/Common/Components/TabsWrapper";
import AudienceTabOption from "./AudienceTabOption";
import styled from "styled-components";
import { useSelector } from "react-redux";
import store, { RootState } from "store";
import { getQueryPageSource, getQueryParam } from "utils";
import { editContactListName, setAppliedSearchInListDetails, setClearSearchTermInListDetails } from "../Lists/actions";
import useQuery from "./../../../../hooks/useQuery";
import { AudienceParams } from "./AudienceHeader";
import { TAB_AUDIENCE } from "constants/paths";
import { AUDIENCE_LISTS, AUDIENCE_LISTS_DETAILS } from "constants/types";
import { setAudiencePeopleSearchTerm } from "../actions";
import { getAudienceListsNamesOnlyService } from "modules/Services/AudienceService";
;

const AudienceHeaderSticky: FC = (props) => {
  const { page, tab, subTab } = useParams<AudienceParams>();
  let query = useQuery();
  const location = useLocation();
  const history = useHistory();

  let goBackURL = "/audiences/lists";
  let fromQuery = query.get("from") || "/audiences/lists";
  let workflowId = query.get("workflow_id");
  if (fromQuery !== "/audiences/lists") {
    const emailId = query.get("email_id");
    fromQuery += "&email_id=" + emailId;
  } else if (workflowId) {
    fromQuery = "/automation/details?workflow_id=" + workflowId;
    goBackURL = "/automation/details?workflow_id=" + workflowId;
  }

  if (query.get("from") === "publish") {
    goBackURL = `/campaigns/editionedit/publish?email_id=${query.get("email_id")}&campaign_id=${query.get(
      "campaign_id"
    )}${query.get("asiderOpen") === "true" ? '&asiderOpen=true' : ''}`;
  }

  if (query.get("from") === "campaign") {
    goBackURL = `/campaigns/content/audience?campaign_id=${query.get("campaign_id")}`;
  }

  // if (subTab === TAB_AUDIENCE.ALL) {
  //   goBackURL = `/audiences/lists/view${location.search}`;
  // }

  // if (window.location.pathname.endsWith("/all")) {
  //   goBackURL = `/audiences/lists/view${window.location.search}`;
  // }

  //* the following will only happen when redirected from analytics content page
  const pageSource = getQueryPageSource();
  if (pageSource === "analytics-content") {
    let queryParams = new URLSearchParams(window.location.search);

    if (queryParams.get("list_id")) {
      queryParams.delete("list_id");
    }
    if (queryParams.get("page_source")) {
      queryParams.delete("page_source");
    }

    fromQuery = `/analytics/content/${queryParams.toString().trim() !== "" ? "?" + queryParams.toString().trim() : ""
      }`;
    goBackURL = `/analytics/content/${queryParams.toString().trim() !== "" ? "?" + queryParams.toString().trim() : ""
      }`;
  }

  const listName = useSelector((state: RootState) => state.audienceListDetails.listName);
  const searchTermListDetails = useSelector((state: RootState) => state.audienceListDetails.searchTermListDetails); // search term in list


  const tabsArray = [
    // {
    //   pillName: "Dashboard",
    //   to: "javascript: void(0);",
    //   isActive: page === undefined || page === "/",
    //   onClick: (e: any) => e.preventDefault(),
    // },
    // {
    //   pillName: "Accounts",
    //   to: `/`,
    //   isActive: page === TAB_ANALYTICS.ACCOUNTS,
    // },
    {
      pillName: "Lists",
      isActive: page === "lists",
      to: `/audiences/lists`,
    },
    {
      pillName: "Contacts",
      isActive: page === "people",
      to: `/audiences/people`,
    },
  ];
  //handler for saving new list name
  function saveNewListName(newName: string) {
    if (listName !== newName) {
      const listId = getQueryParam("list_id");
      editContactListName(listId, newName);
      store.dispatch({
        type: AUDIENCE_LISTS.NAMES_LOAD,
      });
      getAudienceListsNamesOnlyService()
        .then((res) => {
          store.dispatch({
            type: AUDIENCE_LISTS.NAMES_LOAD_SUCCESS,
            listsDataNames: res.data.lists,
          });
        })
        .catch((err) => {
          store.dispatch({
            type: AUDIENCE_LISTS.NAMES_FAIL,
          });
        });
    }
  }

  return (
    <>
      <Wrapper>
        <StickyHeader>
          {tab === TAB_AUDIENCE.VIEW || subTab === TAB_AUDIENCE.ALL ? (
            <StickyHeaderContentWithBackButton
              goBackURL={goBackURL}
              itemName={listName}
              saveNewListName={saveNewListName}
              commasNotAllowed={true} // commas are not allowed in list names
              goBackFunction={() => {
                //* need to handle go back in case of search inside list
                if (searchTermListDetails?.length > 0 && subTab === TAB_AUDIENCE.ALL) {
                  store.dispatch({
                    type: AUDIENCE_LISTS_DETAILS.SET_SEARCH_TERM,
                    searchTermListDetails: "",
                  });
                  setAudiencePeopleSearchTerm("");
                  setClearSearchTermInListDetails(false);
                  setAppliedSearchInListDetails(false);
                }
                // Resets search term when redirects directly from Global Contact Listing to Lists Listing
                if (searchTermListDetails?.length > 0 && subTab === TAB_AUDIENCE.ADD) {
                  store.dispatch({
                    type: AUDIENCE_LISTS_DETAILS.SET_SEARCH_TERM,
                    searchTermListDetails: "",
                  });
                }
                history.push(goBackURL)
              }}
            >
              <TabsWrapper>{<AudienceTabOption tabArray={tabsArray} />}</TabsWrapper>
            </StickyHeaderContentWithBackButton>
          ) : (
            <StickyHeaderContent
              showBack={getQueryParam("email_id").length > 0 || getQueryParam("uuid").length > 0}
              label={"Audiences"}
            >
              <TabsWrapper>{<AudienceTabOption tabArray={tabsArray} />}</TabsWrapper>
            </StickyHeaderContent>
          )}
        </StickyHeader>
      </Wrapper>
    </>
  );
};

export default AudienceHeaderSticky;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 75px;
  @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
    padding-top: 66px;
  }
`;
